<template>
  <div>
    <b-button
      v-b-modal="modalId"
      block
      variant="light"
      class="d-flex justify-content-between align-items-center mt-1"
      :disabled="disabled"
      data-cy="collapse-wrapper"
    >
      <div>
        <slot name="title">
          {{ title }}
        </slot>
        <HelpfulTooltip :text="helpfulTip" />
      </div>

      <PremiumFeature
        v-if="showPremiumFeature"
        class="align-self-start"
        :tooltip-text="premiumFeatureText"
      />

      <font-awesome-icon
        icon="external-link-alt"
        style="color: #999;"
      />
    </b-button>
    <b-modal
      :id="modalId"
      :title="title"
      size="xl"
      :ok-only="okOnly"
      @ok="$emit('ok', $event)"
      @cancel="$emit('cancel', $event)"
      @show="$emit('show', $event)"
    >
      <slot />
    </b-modal>
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

// @ts-ignore uuid not having types
import { v4 as uuidv4 } from 'uuid'
import HelpfulTooltip from '@/components/builder/UI/HelpfulTooltip.vue'
import PremiumFeature from '@/components/builder/UI/PremiumFeature.vue'
import wrapperProps from '@/components/builder/UI/wrapperProps'

const components = {
  HelpfulTooltip,
  PremiumFeature,
}

const props = {
  ...wrapperProps,
  flag: Boolean,
}

@Component({ components })
export default class PopoutWrapper extends Vue.extend({ props }) {
  generatedId = 'popout-wrapper-' + uuidv4()

  get modalId () {
    return this.flag ? 'popout-wrapper-comparison-graph-setting-modal' : this.generatedId + '-modal'
  }
}

</script>
